import {
  getSiteHandle,
  nextTick,
  onMounted,
  useSeo,
  useBuildMetaTags,
  useGtmLayer,
} from "#imports";
import {
  useFetchOtherPageData,
  useFetchOtherPageUrisData,
} from "~/composables/useFetchCraftData";
import { withoutEndingSlash } from "~/utils/route";
import { getGroupSiteHandles } from "~/utils/common";

export const useOtherPage = async () => {
  const previewToken = useState("previewToken", () => null);
  const cinemaPageData = useState("cinemaPageData", () => null);
  const globalPageData = useState("globalPageData", () => null);
  const cinemaPageSeo = useState("cinemaPageSeo", () => null);
  const globalPageSeo = useState("globalPageSeo", () => null);

  const route = useRoute();
  const { setCanonicalLink, setOtherPageHrefLangs } = useBuildMetaTags();

  const pageId = ref(null);

  const gtmLayer = useGtmLayer();

  onMounted(async () => {
    if (previewToken.value !== null) {
      await refresh();
      await nextTick(() => {
        setPageData();
      });
    }

    gtmLayer.trackPageView(cinemaPageSeo.value?.seoTitle || "");
  });

  const { data, refresh } = await useFetchOtherPageData({
    site: getSiteHandle(),
    defaultSite: "default",
    uri: withoutEndingSlash(
      route.path
        ?.replace?.(`/${route.params?.lang}/`, "")
        ?.replace?.(`${route.params?.cinemaslug}/`, ""),
    ),
  });

  const setPageData = () => {
    cinemaPageData.value = data.value.page;
    cinemaPageSeo.value = data.value.pageSeo;
    globalPageData.value = data.value.defaultPage;
    globalPageSeo.value = data.value.defaultPageSeo;
  };

  setPageData();

  const { getSeoMetaData } = useSeo();

  if (data.value) {
    pageId.value = data.value.page?.id || data.value.defaultPage?.id || null;
  }

  const pageSeo = computed(() => {
    if (data.value?.pageSeo) {
      return data.value.pageSeo;
    }
    return data.value?.defaultPageSeo || null;
  });

  if (!pageSeo.value?.seoNoIndex) {
    setCanonicalLink(pageSeo.value?.seoDuplicatePage);
  }

  if (pageId.value && route.params?.cinemaslug) {
    const { data: pageUrisData } = await useFetchOtherPageUrisData({
      site: getGroupSiteHandles(),
      id: pageId.value,
    });
    const pageUris =
      pageUrisData.value?.pageUris || pageUrisData.value?.defaultPageUris || [];

    setOtherPageHrefLangs(route.params?.cinemaslug, pageUris);
  }

  if (data.value?.pageSeo) {
    useHead(getSeoMetaData(data.value?.pageSeo));
  } else if (data.value?.defaultPageSeo) {
    useHead(getSeoMetaData(data.value?.defaultPageSeo));
  }

  const items = computed(() => {
    return data.value?.page?.componentsBuilder?.length
      ? data.value.page.componentsBuilder
      : data.value.defaultPage?.componentsBuilder;
  });

  const pageData = computed(() => {
    return data.value?.page || data.value?.defaultPage;
  });

  return {
    pageData,
    components: items,
  };
};
